<script setup>
import { useChatCustomizer } from '@store/chatCustomizer'
const $chatCustomizer = useChatCustomizer()
</script>

<template>
    <div class="fixed overflow-y-auto flex bg-white top-0 left-0 z-20 h-screen" :style="`width:${$chatCustomizer.sidebarWidth}`">
       <slot></slot>
    </div>
</template>